// extracted by css-extract-rspack-plugin
export default {"cls1":"UserTooltip-cls1_rw8","cls2":"UserTooltip-cls2_PsR UserTooltip-cls1_rw8"};